/* global Promise */

import axios from "axios";
import { GeoJSON } from "ol/format";
import gu from "../utils/geometry.js";

export default {
  getToken(ctx, payload) {
    return axios
      .post(`${ctx.getters.getApiURL}/login`, payload)
      .then(r => {
        if (r.data.token) {
          ctx.commit("setToken", r.data.token);
          ctx.commit("setUsername", payload.username);
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getLastUpdateSource(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/last_update_source?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data.time) {
          return r.data.time;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  getStatusSubService(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/status/subservice?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  sendPasswordResetLink(ctx, payload) {
    return axios
      .post(`${ctx.getters.getApiURL}/reset`, payload)
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  changePasswordUser(ctx, payload) {
    return axios
      .post(`${ctx.getters.getApiURL}/reset/${payload.hashid}`, payload.pass)
      .then(r => {
        if (r.data) {
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  getBookmarks(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/bookmarks?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setBookmarks", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  addBookmark(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/bookmarks?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r.data.updated === true) {
          ctx.commit("setBookmarks", payload);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  removeBookmark(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/bookmarks?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r.data.updated === true) {
          ctx.commit("setBookmarks", payload);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  checkToken(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/check_token?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.status == 200) {
          return true;
        }
        return false;
      })
      .catch(e => {
        return false;
      });
  },
  logout(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/logout`)
      .then(r => {
        ctx.commit("setToken", "");
        ctx.commit("setUsername", "");
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  getDicts(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/dicts?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r) {
          ctx.commit("setDicts", r.data.dictionaries);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  addDict(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/dicts/values?token=${ctx.getters.getToken}`,
        payload
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  getDictSTC(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/dicts/values/${payload.schema}/${payload.table}/${payload.column}?token=${ctx.getters.getToken}`;
    if (payload["with-subdicts"]) {
      url += `&with-subdicts=${payload["with-subdicts"]}`;
    }
    return axios
      .get(url)
      .then(r => {
        return r.data;
      })
      .catch(error => {
        return false;
      });
  },
  getDictST(ctx, payload) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/dicts/values/${payload.schema}/${payload.table}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        return r;
      })
      .catch(error => {
        return false;
      });
  },
  editDict(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/dicts/values/${payload.newId}?token=${ctx.getters.getToken}`,
        payload.content
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  removeDict(ctx, dictId) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/dicts/values/${dictId}?token=${ctx.getters.getToken}`
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  getLayers(ctx) {
    // Get list of layers and their attributes
    return axios
      .get(`${ctx.getters.getApiURL}/layers?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setLayers", r.data.layers);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  getSimpleLayers(ctx) {
    // Get list of layers and their attributes
    return axios
      .get(
        `${ctx.getters.getApiURL}/layers?simple=true&token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r.data.layers;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  getSrid(ctx) {
    // Get list of layers and their attributes
    return axios
      .get(`${ctx.getters.getApiURL}/srid?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setSrid", `EPSG:${r.data}`);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  getLayer(ctx, layername) {
    // Get properties of individual layer
    return axios
      .get(
        `${ctx.getters.getApiURL}/layers/${layername}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          ctx.commit("setLayer", r.data);
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getAppLayers(ctx) {
    // Get list of app layers ("Warstwy dodatkowe")
    return axios
      .get(`${ctx.getters.getApiURL}/app_layers?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setAppLayers", r.data.app_layers);
          return true;
        }
        return false;
      });
  },
  getAppLayersMeta(ctx) {
    // Get app layers metadata ("Warstwy dodatkowe")
    return axios
      .get(
        `${ctx.getters.getApiURL}/app_layers?token=${ctx.getters.getToken}&meta=true`
      )
      .then(r => {
        if (r.data) {
          ctx.commit("setAppLayersMeta", r.data.app_layers);
          return true;
        }
        return false;
      });
  },
  getUserLayers(ctx) {
    ctx.state.loadToMap.user = true;
    return axios
      .get(
        `${ctx.getters.getApiURL}/users_layers?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          const layers = r.data.layers || [];
          layers.forEach(layer => {
            layer.geometry_type = gu.toGeometryType(layer.geometry_type);
          });
          ctx.commit("setUserLayers", layers);
          return true;
        }
        return false;
      });
  },
  getWMSLayers(ctx) {
    ctx.state.loadToMap.wms = true;
    return axios
      .get(`${ctx.getters.getApiURL}/wms?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          return r.data.wmses;
        }
        return false;
      });
  },

  getUserLayerMetadata(ctx, table) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/users_layers/${table}/metadata?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data && r.data.layers && r.data.layers.length > 0) {
          return r.data.layers[0];
        }
        return false;
      });
  },

  removeUserLayer(ctx, table) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/users_layers/${table}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        return r;
      })
      .catch(error => ({
        status: 500,
        message: error.response.data.message
      }));
  },
  removeWMSLayer(ctx, id) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/wms/${id}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        return r;
      })
      .catch(error => ({
        status: 500,
        message: error.response.data.message
      }));
  },
  removeUserRasterLayer(ctx, id) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/geoserver_api/raster/${id}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        return r;
      })
      .catch(error => ({
        status: 500,
        message: error.response.data.message
      }));
  },
  removeSketcheLayer(ctx, id) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/sketches/${id}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        return r;
      })
      .catch(error => ({
        status: 500,
        message: error.response.data.message
      }));
  },

  addEmptyUserLayer(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/users_layers/new?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        return r;
      })
      .catch(error => ({
        status: 500,
        message: error.response.data.message
      }));
  },
  getBaselayers(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/baselayers?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setBaselayers", r.data.baselayers);
          return true;
        }
        return false;
      });
  },
  getUsersRasters(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/users_rasters?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r.data;
        }
        return false;
      });
  },
  getFeatures(ctx, payload) {
    // Get features of a layer as GeoJSON
    let path = `srid=${payload.srid}&token=${ctx.getters.getToken}`;
    if ("filter" in payload) {
      path += `&filter=${payload.filter}`;
    }
    if ("with_geometry" in payload) {
      path += `&with_geometry=${payload.with_geometry}`;
    }

    const url = `${ctx.getters.getApiURL}/features/${payload.layername}?${path}`;
    return axios.get(url).then(r => {
      return r.data;
    });
  },
  getFeature(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/features/${payload.object_table}/${payload.object_id}?&token=${ctx.getters.getToken}`;
    return axios
      .get(url)
      .then(r => {
        return r.data
          ? new GeoJSON().readFeature(r.data, {
              featureProjection: payload.srid,
              dataProjection: ctx.state.srid
            })
          : r;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getAppLayersFeature(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/app_layers/${payload.object_table}/${payload.object_id}?&token=${ctx.getters.getToken}`;
    return axios
      .get(url)
      .then(r => {
        return r.data
          ? new GeoJSON().readFeature(r.data, {
              featureProjection: payload.srid,
              dataProjection: ctx.state.srid
            })
          : r;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getUserLayerFeatures(ctx, payload) {
    // Get features of a layer as GeoJSON
    return axios
      .get(
        `${ctx.getters.getApiURL}/users_layers/${payload.layername}?srid=${payload.srid}&token=${ctx.getters.getToken}`
      )
      .then(r => {
        return r.data;
      });
  },
  editUserLayer(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/users_layers/${payload.table}?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(res => {
        return res;
      })
      .catch(error => ({
        status: 500,
        message: error.response.data.message
      }));
  },
  editUserLayerFeature(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/users_layers/update?token=${ctx.getters.getToken}`,
        payload
      )
      .then(res => {
        return res;
      })
      .catch(error => ({
        status: 500,
        message: error.response.data.message
      }));
  },
  editFeature(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/features_attributes/${payload.table}?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response;
      });
  },
  getStyles(ctx) {
    if (localStorage.layers_styles) {
      ctx.commit("setStyles", JSON.parse(localStorage.layers_styles));
      return Promise.resolve(true);
    } else {
      return axios
        .get(
          `${ctx.getters.getApiURL}/styles?with_id=true&token=${ctx.getters.getToken}`
        )
        .then(r => {
          if (r.data) {
            ctx.commit("setStyles", r.data.styles);
            return true;
          }
          return false;
        });
    }
  },
  setStyle(ctx, payload) {
    if (payload.sid) {
      return axios
        .put(
          `${ctx.getters.getApiURL}/styles/${payload.sid}?token=${ctx.getters.getToken}`,
          payload.body.layer_style
        )
        .then(r => {
          if (r.data) {
            return [true, r.data.updated];
          }
          return [false, "Błąd"];
        })
        .catch(error => [false, error]);
    } else {
      return axios
        .post(
          `${ctx.getters.getApiURL}/styles?token=${ctx.getters.getToken}`,
          payload.body
        )
        .then(r => {
          if (r.data) {
            return [true, r.data.inserted];
          }
          return [false, "Błąd"];
        })
        .catch(error => [false, error]);
    }
  },
  getIcons(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/icons?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          return r.data;
        }
        return r.data.message;
      });
  },
  getIconsTemplates(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/icons/templates?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r.data;
        }
        return r.data.message;
      });
  },
  sendDictValues(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/dicts/values?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r.data) {
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },

  getSketches(ctx) {
    // lista szkicy
    ctx.state.loadToMap.sketche = true;
    return axios
      .get(`${ctx.getters.getApiURL}/sketches?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setSketches", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  getSketcheFeatures(ctx, payload) {
    // Get features of a layer as GeoJSON
    return axios
      .get(
        `${ctx.getters.getApiURL}/sketches/${payload.id}?token=${ctx.getters.getToken}`
      )
      .then(r => r.data);
  },

  // INSPECTIONS
  getInspectionTasks(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/inspections/tasks?token=${ctx.getters.getToken}`;
    if (payload && payload.cards) {
      url += `&inspections=${payload.cards}`;
    }
    return axios
      .get(url)
      .then(r => {
        if (r.data) {
          ctx.commit("setInspectionTasks", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  addInspectionTask(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/inspections/tasks?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        return r;
      })
      .catch(error => {
        return false;
      });
  },
  getInspectionTask(ctx, oid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/inspections/tasks/${oid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          ctx.commit("setInspectionTask", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  removeInspectionTask(ctx, oid) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/inspections/tasks/${oid}?token=${ctx.getters.getToken}`
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  editInspectionTask(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/inspections/tasks/${payload.id}?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  getInspectionCards(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/inspections?token=${ctx.getters.getToken}`;
    return axios
      .get(url, {
        params: payload
      })
      .then(r => {
        if (r.data) {
          ctx.commit("setInspectionCards", r.data);
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  addHydrantInspection(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/inspections?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        return true;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getHydrantInspectionCard(ctx, oid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/inspections/${oid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          ctx.commit("setHydrantInspectionCard", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  removeInspectionCard(ctx, oid) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/inspections/${oid}?token=${ctx.getters.getToken}`
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  editInspectionCard(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/inspections/${payload.id}?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(r => {
        if (r.data) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  inspectionReport(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/inspections/tasks/report?token=${ctx.getters.getToken}`,
        payload,
        {
          responseType: "arraybuffer"
        }
      )
      .then(response => {
        let url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/pdf"
          })
        );
        const link = document.createElement("a");
        link.href = url;
        let date = new Date()
          .toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          })
          .substr(0, 10);

        link.download = "karta_inspekcji" + date + ".pdf";

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  hydrantCardReport(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/inspections/hydrants/report?token=${ctx.getters.getToken}`,
        payload,
        {
          responseType: "arraybuffer"
        }
      )
      .then(response => {
        let url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/pdf"
          })
        );
        const link = document.createElement("a");
        link.href = url;
        let date = new Date()
          .toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          })
          .substr(0, 10);

        link.download = "karta_hydrantu" + date + ".pdf";

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  // REPORTS
  networkReport(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/reports/${payload.type}?token=${ctx.getters.getToken}`,
        payload,
        {
          responseType: "arraybuffer"
        }
      )
      .then(response => {
        let url = URL.createObjectURL(
          new Blob([response.data], {
            type: response.headers["content-type"]
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.download =
          "raport_sieci." + response.headers["content-type"].split("/")[1];
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  // SCHEDULES
  getSchedules(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/schedules?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setSchedules", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  addSchedule(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/schedules?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  editSchedule(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/schedules/${payload.oid}?token=${ctx.getters.getToken}`,
        payload.content
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  // TASKS
  getTasks(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/tasks?token=${ctx.getters.getToken}`;
    for (let element in payload) {
      url += `&${element}=${payload[element]}`;
    }
    return axios
      .get(url)
      .then(r => {
        if (r.data) {
          let data = {
            tasks: []
          };
          data.tasks = r.data.tasks.map(task => {
            let temp_task = Object.assign({}, task);
            temp_task.reported_operator = {};
            temp_task.reported_operator.id = task.reported_operator;
            temp_task.reported_operator.name = ctx.getters.getUsers.find(
              user => user.id == temp_task.reported_operator.id
            ).name;
            return temp_task;
          });
          ctx.commit("setTasks", data);
          return r.data;
        } else {
          return false;
        }
      })
      .catch(error => {
        return false;
      });
  },
  getTask(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/tasks/${payload.oid}?token=${ctx.getters.getToken}`;
    for (let element in payload) {
      if (element != "oid") url += `&${element}=${payload[element]}`;
    }
    return axios
      .get(url)
      .then(r => {
        if (r.data) {
          ctx.commit("setTask", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  getTaskMaterials(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/task_materials?token=${ctx.getters.getToken}`;
    for (let element in payload) {
      url += `&${element}=${payload[element]}`;
    }
    return axios
      .get(url)
      .then(r => {
        if (r.data) {
          ctx.commit("setTaskMaterials", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  addTask(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/tasks?token=${ctx.getters.getToken}`;

    if (payload.srid) url += `&srid=${payload.srid}`;
    return axios
      .post(url, payload)
      .then(r => {
        return r;
      })
      .catch(error => {
        return false;
      });
  },

  addTaskMaterials(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/tasks_materials?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        return r;
      })
      .catch(error => {
        return false;
      });
  },
  editTask(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/tasks/${payload.id}?token=${ctx.getters.getToken}`;
    // if (payload.srid) url += `srid=${payload.srid}`
    // url += `token=${ctx.getters.getToken}`
    return axios
      .put(url, payload)
      .then(r => {
        return r;
      })
      .catch(e => {
        return e.response.data.message;
      });
  },
  editTaskMaterials(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/tasks_materials/${payload.oid}?token=${ctx.getters.getToken}`;
    return axios
      .put(url, payload.body)
      .then(r => {
        return r;
      })
      .catch(error => {
        return false;
      });
  },
  deleteTask(ctx, oid) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/tasks/${oid}?token=${ctx.getters.getToken}`
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return error;
      });
  },
  deleteTaskMaterials(ctx, oid) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/tasks_materials/${oid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        return r;
      })
      .catch(error => {
        return error;
      });
  },
  taskReport(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/tasks/report?token=${ctx.getters.getToken}`,
        payload,
        {
          responseType: "arraybuffer"
        }
      )
      .then(response => {
        let url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/pdf"
          })
        );
        const link = document.createElement("a");
        link.href = url;
        let date = new Date()
          .toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          })
          .substr(0, 10);
        link.download = "karta_zadania" + date + ".pdf";
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  // folders
  getFolders(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/folders?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setFolders", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  getFolderData(ctx, fid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/folders/${fid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          ctx.commit("setFolderData", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  editFolderData(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/folders/${payload.id}?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  // attachments
  getAttachments(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/attachments?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setAttachments", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  sendAttachments(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/attachments?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getAttachmentsForObject(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/attachments/${payload.object_type}?oid=${payload.oid}&token=${ctx.getters.getToken}`;
    if (payload.hasOwnProperty("layer")) {
      url += `&layer=${payload.layer}`;
    }
    return axios
      .get(url)
      .then(r => {
        if (r.data) {
          ctx.commit("setObjectAttachments", r.data);
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  getAttachmentsObjects(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/attachments/objects/${payload.filename}?token=${ctx.getters.getToken}`;
    if (payload.hasOwnProperty("layer")) {
      url += `&layer=${payload.layer}`;
    }
    return axios
      .get(url)
      .then(r => {
        if (r.data) {
          console.log(r);
          return r;
        }
        return false;
      })
      .catch(error => {
        return error;
      });
  },
  downloadAttachment(ctx, payload) {
    let link = document.createElement("a");
    let att = document.createAttribute("target");
    att.value = "_blank";
    link.setAttributeNode(att);
    link.download = payload.filename;
    link.href = `${ctx.getters.getApiURL}/download/${payload.id}?token=${ctx.getters.getToken}`;
    document.body.appendChild(link);
    if ("trigger" in link) {
      link.trigger("click");
    } else if ("click" in link) {
      link.click();
    } else {
      return false;
    }
    link.remove();
    return true;
  },
  removeAttachment(ctx, id) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/attachments/${id}?token=${ctx.getters.getToken}`
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  addAttachmentToObject(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/attachments/${payload[0]}?token=${ctx.getters.getToken}`,
        payload[1]
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response;
      });
  },
  // user fields
  addField(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/fields/${payload.table}?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  removeField(ctx, payload) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/fields/${payload.table}/${payload.field}?token=${ctx.getters.getToken}`
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  editField(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/fields/${payload.table}/${payload.field}?token=${ctx.getters.getToken}`,
        payload.content
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  // events
  getEvents(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/events?token=${ctx.getters.getToken}`;
    if ("user" in payload) url += `&user=${payload.user}`;
    if ("limit" in payload) url += `&limit=${payload.limit}`;
    if ("last" in payload) url += `&last=${payload.last}`;
    if ("object_id" in payload && payload.object_id != undefined)
      url += `&object_id=${payload.object_id}`;
    if ("object_type" in payload && payload.object_type != undefined)
      url += `&object_type=${payload.object_type}`;
    if ("object_table" in payload && payload.object_table != undefined)
      url += `&object_table=${payload.object_table}`;
    if ("search_text" in payload && payload.search_text != undefined)
      url += `&search_text=${payload.search_text}`;
    return axios
      .get(url)
      .then(r => {
        if (r.data) {
          ctx.commit("setEvents", r.data.events);
          return r;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  addEvent(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/events?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  getFeatureEvents(ctx, payload) {
    let isInspection = payload.isInspection;
    delete payload.isInspection;
    if (payload.object_table == undefined) {
      var url = `${ctx.getters.getApiURL}/events?object_id=${payload.object_id}&object_type=${payload.object_type}&limit=${payload.limit}&last=${payload.last}&events_count=${payload.events_count}&token=${ctx.getters.getToken}`;
    } else {
      if (payload.object_table == "inspections") {
        var url = `${ctx.getters.getApiURL}/events?object_id=${payload.object_id}&object_table=${payload.object_table}&limit=${payload.limit}&last=${payload.last}&events_count=${payload.events_count}&token=${ctx.getters.getToken}`;
      } else {
        var url = `${ctx.getters.getApiURL}/events?object_id=${payload.object_id}&object_type=${payload.object_type}&object_table=${payload.object_table}&limit=${payload.limit}&last=${payload.last}&events_count=${payload.events_count}&token=${ctx.getters.getToken}`;
      }
    }
    return axios
      .get(url)
      .then(r => {
        if (r.data) {
          if (!isInspection) {
            ctx.commit("setFeatureEvents", r.data);
          }
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  // PRINT
  printMap(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/mapprint?token=${ctx.getters.getToken}`,
        payload,
        {
          responseType: "arraybuffer"
        }
      )
      .then(response => {
        let type = "";
        if (
          payload.format == "png" &&
          payload.split == true &&
          (payload.size == "A3" ||
            payload.size == "A2" ||
            payload.size == "A1" ||
            payload.size == "A0")
        ) {
          type = "zip";
        } else {
          type = payload.format == "pdf" ? "pdf" : "png";
        }
        let url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/" + type
          })
        );
        const link = document.createElement("a");
        link.href = url;
        let date = new Date()
          .toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          })
          .substr(0, 10);
        if (
          payload.format == "png" &&
          payload.split == true &&
          (payload.size == "A3" ||
            payload.size == "A2" ||
            payload.size == "A1" ||
            payload.size == "A0")
        ) {
          link.download = "wydruk_mapy" + date + ".zip";
        } else {
          link.download =
            "wydruk_mapy" + date + (payload.format == "pdf" ? ".pdf" : ".png");
        }
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  // ANALYSIS
  getPhoneNumbers(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/phone_numbers?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  sendSMS(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/send-sms?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  computeCutoff(ctx, coords) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/cutoff?lng=${coords[0]}&lat=${coords[1]}&token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response;
      });
  },
  getStatistics(ctx, payload) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/statistics/${payload.table}?${payload.columns}&token=${ctx.getters.getToken}`,
        {
          responseType: "blob"
        }
      )
      .then(r => {
        if (r) {
          let url = URL.createObjectURL(new Blob([r.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `statystyki_${payload.name}.xlsx`);
          document.body.appendChild(link);
          link.click();
          return true;
        }
        return false;
      })
      .catch(error => {
        return error.response;
      });
  },
  generateCutoffRaport(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/cutoff/report?token=${ctx.getters.getToken}`,
        payload,
        {
          responseType: "arraybuffer"
        }
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
  },
  // SERVITUDE
  getServitudes(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/transmission-easement?token=${ctx.getters.getToken}`;
    if ("srid" in payload) {
      url += `&srid=${payload.srid}`;
    }
    if ("with_geometry" in payload) {
      url += "&with_geometry=true";
    } else if ("with_bbox" in payload) {
      url += "&with_bbox=true";
    }

    return axios
      .get(url)
      .then(r => {
        if (r.data) {
          ctx.commit("setServitudes", r.data);
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  getAnalysisResult(ctx, srid) {
    if (!srid) {
      var url = `${ctx.getters.getApiURL}/transmission-easement/analysis?token=${ctx.getters.getToken}`;
    } else {
      var url = `${ctx.getters.getApiURL}/transmission-easement/analysis?srid=${srid}&token=${ctx.getters.getToken}`;
    }
    return axios
      .get(url)
      .then(r => {
        if (r.data) {
          ctx.commit("setAnalysisResult", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return error;
      });
  },
  analyseServitude(ctx, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${ctx.getters.getApiURL}/transmission-easement/analysis?token=${ctx.getters.getToken}`,
          payload
        )
        .then(r => {
          if (r.data) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveAnalysisResult(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/transmission-easement/analysis/${payload.oid}?token=${ctx.getters.getToken}`
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  servitudeReport(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/transmission-easement/report?token=${ctx.getters.getToken}`,
        payload,
        {
          responseType: "arraybuffer"
        }
      )
      .then(response => {
        let url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/pdf"
          })
        );
        const link = document.createElement("a");
        link.href = url;
        let date = new Date()
          .toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          })
          .substr(0, 10);

        link.download = "karta_sluzebnosci" + date + ".pdf";

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  getServitude(ctx, payload) {
    let url = `${ctx.getters.getApiURL}/transmission-easement/${payload.object_id}?token=${ctx.getters.getToken}`;
    if ("with_geometry" in payload) {
      url += "&with_geometry=true";
    } else if ("with_bbox" in payload) {
      url += "&with_bbox=true";
    }
    return axios
      .get(url)
      .then(r => {
        if (r.data) {
          ctx.commit("setServitudeData", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  editServitude(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/transmission-easement/${payload.id}?token=${ctx.getters.getToken}`,
        payload
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  removeServitude(ctx, oid) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/transmission-easement/${oid}?token=${ctx.getters.getToken}`
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  // VARIANCES
  getVariances(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/variances?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setVariancesList", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  getSingleDict(ctx, oid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/dicts/values/${oid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return error.response;
      });
  },
  addVariance(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/variances?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r.data) {
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  editVariance(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/variances/${payload.id}?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(r => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  removeVariance(ctx, id) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/variances/${id}?token=${ctx.getters.getToken}`
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  // editFeature(ctx, payload) {
  //   return axios
  //     .put(
  //       `${ctx.getters.getApiURL}/features_attributes/${payload.table}?token=${
  //       ctx.getters.getToken
  //       }`,
  //       payload.body
  //     )
  //     .then(() => {
  //       return true;
  //     })
  //     .catch(error => {
  //       return false;
  //     });
  // },
  // SCADA
  addScadaPoint(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/scada/points?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        return r;
      })
      .catch(error => {
        return error.response;
      });
  },
  removeScadaPoint(ctx, scadaid) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/scada/points/${scadaid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        return r;
      })
      .catch(error => {
        return error.response;
      });
  },
  getScadaPoints(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/scada/points?srid=2180&token=${ctx.getters.getToken}`
      )
      .then(r => {
        for (let feat of r.data.features) {
          ctx.commit("setScadaPoints", feat);
        }
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  getScadaPoint(ctx, pointID) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/scada/points/${pointID}?srid=2180&token=${ctx.getters.getToken}`
      )
      .then(r => {
        ctx.commit("setCurrentScadaPoint", r.data);
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  editScadaPoint(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/scada/points/${payload.id}?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  getMeasuresList(ctx, oid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/scada/measures-list/${oid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        return r.data;
      })
      .catch(error => {
        return false;
      });
  },
  getMeasures(ctx, oid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/scada/measures/${oid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        return r.data;
      })
      .catch(error => {
        return false;
      });
  },
  getMeasuresRange(ctx, payload) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/scada/measures/${payload.oid}?from=${payload.from}&to=${payload.to}&token=${ctx.getters.getToken}`
      )
      .then(r => {
        return r.data;
      })
      .catch(error => {
        return false;
      });
  },
  // SETTINGS
  getViews(ctx, isData) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/shared-views?index=${isData}&token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  addView(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/shared-views?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  removeView(ctx, hash_oid) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/shared-views/${hash_oid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getHistory(ctx, verbose) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/history?verbose=true&token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getSingleHistory(ctx, payload) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/history/${payload.table}/${payload.oid}?verbose=${payload.verbose}&token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getHistoryChange(ctx, payload) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/history/${payload.uid}?verbose=${payload.verbose}&token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getUsers(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/users?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setUsers", r.data.users);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  getUser(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/user?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setUser", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  addUser(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/users?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  removeUser(ctx, userid) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/users/${userid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  addGroup(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/groups?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r.data) {
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  removeGroup(ctx, groupid) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/groups/${groupid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  modifyUser(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/users/${payload.uid}?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(r => {
        if (r) {
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  resetPassword(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/reset/${payload.hashid}?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(r => {
        if (r) {
          return true;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getGroups(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/groups?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  getPermissionsList(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/permissions?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getUserGroup(ctx, groupid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/groups/${groupid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  updateGroupPermissions(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/groups/${payload.groupid}?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  getSettings(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/settings?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setSettings", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  changeSettings(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/settings?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        return r;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getSingleSettings(ctx, name) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/settings/${name}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        return r.data;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  // FAILURES
  generateAd(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/failures/announcement?token=${ctx.getters.getToken}`,
        payload,
        {
          responseType: "arraybuffer"
        }
      )
      .then(response => {
        let url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/pdf"
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.download = "ogloszenie_przerwa_w_dostawie_wody.pdf";
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return response;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getFailures(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/failures?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setFailures", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  addFailure(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/failures?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        return r;
      })
      .catch(error => {
        return false;
      });
  },
  editFailure(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/failures/${payload.oid}?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  deleteFailure(ctx, oid) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/failures/${oid}?token=${ctx.getters.getToken}`
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  failureReport(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/failures/report?token=${ctx.getters.getToken}`,
        payload,
        {
          responseType: "arraybuffer"
        }
      )
      .then(response => {
        let url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/pdf"
          })
        );
        const link = document.createElement("a");
        link.href = url;
        let date = new Date()
          .toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          })
          .substr(0, 10);

        link.download = "karta_zadania" + date + ".pdf";

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  failureNetworkReport(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/failures/network_report?token=${ctx.getters.getToken}`,
        payload,
        {
          responseType: "arraybuffer"
        }
      )
      .then(r => {
        if (r.data) {
          let url = URL.createObjectURL(
            new Blob([r.data], {
              type: "application/pdf"
            })
          );
          const link = document.createElement("a");
          link.href = url;
          let date = new Date()
            .toLocaleString("pl-PL", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit"
            })
            .substr(0, 10);

          link.download = "karta_awarii_sieci" + date + ".pdf";

          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          return r;
        }
        return false;
      })
      .catch(error => {
        let decodedString = String.fromCharCode.apply(
          null,
          new Uint8Array(error.response.data)
        );
        let obj = JSON.parse(decodedString);
        return obj.message;
      });
  },
  // GEOSERVER RASTER
  deleteRaster(ctx, rasterID) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/geoserver_api/raster/${rasterID}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        return r.data;
      })
      .catch(error => {
        return false;
      });
  },
  addGeoserverRaster(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/geoserver_api?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        return r.data;
      })
      .catch(error => {
        return false;
      });
  },
  // Refurubishments / repairs
  getRefurbishments(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/repairs?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          ctx.commit("setRefurbishments", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  addRefurbishment(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/repairs?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        return r;
      })
      .catch(error => {
        return false;
      });
  },
  editRefurbishment(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/repairs/${payload.oid}?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  deleteRefurbishment(ctx, oid) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/repairs/${oid}?token=${ctx.getters.getToken}`
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  refurbishmentReport(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/repairs/report?token=${ctx.getters.getToken}`,
        payload,
        {
          responseType: "arraybuffer"
        }
      )
      .then(response => {
        let url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/pdf"
          })
        );
        const link = document.createElement("a");
        link.href = url;
        let date = new Date()
          .toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          })
          .substr(0, 10);

        link.download = "karta_remontu" + date + ".pdf";

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  // Costs
  getCosts(ctx, payload) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/costs/${payload.table}/${payload.oid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          if (payload.table == "failures") {
            ctx.commit("setFailureCosts", r.data);
            return true;
          } else if (payload.table == "repairs") {
            ctx.commit("setRefurbishmentCosts", r.data);
            return true;
          } else if (payload.table == "tasks") {
            ctx.commit("setTaskCosts", r.data);
            return true;
          }
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  // wyszukiwarka
  getObject(ctx, payload) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/search/${payload.table}?srid=2180&term=${payload.term}&token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return false;
      });
  },
  // modelWat
  changeModellingOptions(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/options?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  showLatestModelling(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/hydraulics/latest?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  doModelling(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/hydraulics?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response;
      });
  },
  getVirtualRecipients(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/virtual-recipients?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          ctx.commit("setVirtualRecipients", r.data);
          return true;
        } else {
          return false;
        }
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getVirtualRecipient(ctx, oid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/virtual-recipients/${oid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          ctx.commit("setVirtualRecipient", r.data);
          return true;
        } else {
          return false;
        }
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  addVirtualRecipient(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/virtual-recipients?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        return r;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  editVirtualRecipient(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/virtual-recipients/${payload.oid}?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(r => {
        return r;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  deleteVirtualRecipient(ctx, oid) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/virtual-recipients/${oid}?token=${ctx.getters.getToken}`
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  getCurves(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/curves?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r.data) {
          return r.data;
        } else {
          return false;
        }
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getCurvesForModelWat(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/curves?types=0&token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r.data;
        } else {
          return false;
        }
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  addNewCurve(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/curves?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r.data) {
          return r;
        } else {
          return false;
        }
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  deleteCurve(ctx, oid) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/curves/${oid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  editCurveValues(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/curves/${payload.oid}?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  checkGraph(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/water-model/validate?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  exportGraph(ctx, parameters) {
    let paramString = "status=";
    for (let status of parameters.status) {
      paramString += `${status},`;
    }
    paramString = paramString.slice(0, -1);
    paramString += "&net_kind=";
    for (let kind of parameters.net_kind) {
      paramString += `${kind},`;
    }
    paramString = paramString.slice(0, -1);
    return axios
      .get(
        `${ctx.getters.getApiURL}/epanet/file?${paramString}&token=${ctx.getters.getToken}`,
        {
          responseType: "arraybuffer"
        }
      )
      .then(r => {
        if (r) {
          const url = window.URL.createObjectURL(new Blob([r.data]));
          const link = document.createElement("a");
          let date = new Date().toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
          });

          date = date.replace(/:|,/g, ".").split(".");
          link.href = url;
          link.setAttribute(
            "download",
            `${date[2]}_${date[1]}_${date[0]}_ ${date[3]}_${date[4]}_${date[5]}.inp`
          );
          document.body.appendChild(link);
          link.click();
          return r;
        }
        return false;
      })
      .catch(error => {
        let decodedString = String.fromCharCode.apply(
          null,
          new Uint8Array(error.response.data)
        );
        let obj = JSON.parse(decodedString);
        return obj.message;
      });
  },
  waterModelFix(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/water-model/fix?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r.status == 200) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  exportCanFile(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/swmm/export.fsew?token=${ctx.getters.getToken}`,
        {
          responseType: "arraybuffer"
        }
      )
      .then(response => {
        let url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/pdf"
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.download = "export.fsew";
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return true;
      });
  },
  generateChart(ctx, geometry) {
    // Generowanie profilu podÅ‚uÅ¼nego terenu
    return axios
      .post(
        `${ctx.getters.getApiURL}/profile?token=${ctx.getters.getToken}`,
        geometry
      )
      .then(r => {
        if (r.status == 200) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  //model kan
  computeClogs(ctx, coords) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/clogs?x=${coords[0]}&y=${coords[1]}&srid=2180&token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response;
      });
  },
  // video wideo
  getVideoInspectionCards(ctx, payload) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/video?attachments=${payload.attachments}&pipes=${payload.pipes}&token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          ctx.commit("setVideoInspectionCards", r.data);
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getVideoInspectionCard(ctx, oid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/video/${oid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          ctx.commit("setVideoInspectionCard", r.data);
          return true;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  videoAuthorization(ctx, filename) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/video/auth/${filename}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.data) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getProfile(ctx, oid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/video/profile/${oid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  addVideoInspectionCard(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/video?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response;
      });
  },
  uploadVideo(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/video/upload/${payload.oid}?token=${ctx.getters.getToken}`,
        payload.filename
      )
      .then(r => {
        return r;
      })
      .catch(error => {
        return false;
      });
  },
  videoReport(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/video/report?token=${ctx.getters.getToken}`,
        payload,
        {
          responseType: "arraybuffer"
        }
      )
      .then(response => {
        let url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/pdf"
          })
        );
        const link = document.createElement("a");
        link.href = url;
        let date = new Date()
          .toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          })
          .substr(0, 10);

        link.download = "karta_inspekcji_wideo" + date + ".pdf";
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  editVideoInspectionCard(ctx, payload) {
    return axios
      .put(
        `${ctx.getters.getApiURL}/video/${payload.oid}?token=${ctx.getters.getToken}`,
        payload.body
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  deleteVideoInspectionCard(ctx, oid) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/video/${oid}?token=${ctx.getters.getToken}`
      )
      .then(() => {
        return true;
      })
      .catch(error => {
        return false;
      });
  },
  // Profile podÅ‚uÅ¼ne
  getSewersProfile(ctx, payload) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/sewers-profile/${payload.start}/${payload.end}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        if (error.response) return error.response.data.message;
        else return error;
      });
  },
  getWatersProfile(ctx, payload) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/waters-profile/${payload.start}/${payload.end}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  // HydraNet
  getHydraNetWatermeters(ctx, srid) {
    let url = `${ctx.getters.getApiURL}/hydranet?token=${ctx.getters.getToken}`;
    if (srid) url += `&srid=${srid}`;
    return axios
      .get(url)
      .then(r => {
        if (r.data) {
          ctx.commit("setHydraNetWatermeters", r.data);
          return r;
        }
        return false;
      })
      .catch(error => {
        if (error.response) return error.response.data.message;
        else return error;
      });
  },
  // DOKUMENTY
  getAcceptanceDocs(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/investments/acceptance_documentation?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getInvestmentsProcesses(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/investments/process?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getDocumentation(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/investments/documentation?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getTechPreconditions(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/investments/technical_preconditions?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getApplications(ctx) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/investments/applications?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getInvestments(ctx) {
    return axios
      .get(`${ctx.getters.getApiURL}/investments?token=${ctx.getters.getToken}`)
      .then(r => {
        if (r) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getInvestmentApplication(ctx, oid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/investments/${oid}/applications?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r;
        }
        return "a";
      })
      .catch(error => {
        return JSON.stringify(error.response.status);
      });
  },
  getInvestmentPreconditions(ctx, oid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/investments/${oid}/technical_preconditions?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return JSON.stringify(error.response.status);
      });
  },
  getInvestmentDocumentation(ctx, oid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/investments/${oid}/documentation?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return JSON.stringify(error.response.status);
      });
  },
  getInvestmentProcess(ctx, oid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/investments/${oid}/process?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return JSON.stringify(error.response.status);
      });
  },
  getInvestmentAcceptance(ctx, oid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/investments/${oid}/acceptance_documentation?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return JSON.stringify(error.response.status);
      });
  },
  editInvestments(ctx, payload) {
    let path;
    if (payload.parameter.length > 0) {
      path = `/${payload.parameter}`;
    } else {
      path = "";
    }

    const url = `${ctx.getters.getApiURL}/investments/${payload.oid}${path}?token=${ctx.getters.getToken}`;
    return axios
      .put(url, payload.body)
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.status;
      });
  },
  getSingleInvestment(ctx, oid) {
    return axios
      .get(
        `${ctx.getters.getApiURL}/investments/${oid}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r.data;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  addInvestment(ctx, payload) {
    return axios
      .post(
        `${ctx.getters.getApiURL}/investments?token=${ctx.getters.getToken}`,
        payload
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  addInvestmentDetail(ctx, payload) {
    let path;
    if (payload.parameter.length > 0) {
      path = `/${payload.parameter}`;
    } else {
      path = "";
    }

    const url = `${ctx.getters.getApiURL}/investments/${payload.oid}${path}?token=${ctx.getters.getToken}`;
    return axios
      .post(url, payload.body)
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.status;
      });
  },
  removeInvestmentFeature(ctx, payload) {
    return axios
      .delete(
        `${ctx.getters.getApiURL}/investments/${payload.oid}${payload.feature}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  },
  getFeatureInvestments(ctx, payload) {
    const { object_type, object_layer, object_id } = payload;
    return axios
      .get(
        `${ctx.getters.getApiURL}/investments/${object_type}/${object_layer}/${object_id}?token=${ctx.getters.getToken}`
      )
      .then(r => {
        if (r.status === 200) {
          return r;
        }
        return false;
      })
      .catch(error => {
        return error.response.data.message;
      });
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js